const NAVIGATION_TABS = {
    HOME: 'HOME',
    SEARCH: 'SEARCH',
    WORKSPACES: 'WORKSPACES',
    SETTINGS: 'SETTINGS',
} as const;

export default NAVIGATION_TABS;
